
export default function FieldIntro({ intro, onChange }) {
	return (
		<div className="relative">
			<textarea
				id="profile-intro"
				value={intro ?? ""}
				onChange={onChange}
				rows={4}
				dir="auto"
				className="w-full font-Vazir-400 rounded-xl border border-[#E2E8F0] px-4 pt-6 pb-3 text-[15px] text-midGray resize-y min-h-[120px] focus:outline-none focus:border-darkBlue/40 focus:ring-2 focus:ring-darkBlue/10"
				placeholder="چند خط درباره خودتان بنویسید…"
			/>
			<label
				htmlFor="profile-intro"
				className="absolute right-4 -top-2.5 bg-white px-1 text-grayText font-Vazir-500 text-[13px]"
			>
				معرفی
			</label>
		</div>
	);
}
